import React, { useState, useEffect } from 'react';
// Import the CSS file to apply the styles
import './css/LoginPage.css';
import axios from 'axios';

// Define the props for the LoginPage component
interface LoginPageProps {
  onLoginSuccess: (username: string, rememberMe: boolean) => void;
}

const onNavigate = (page: string) => {
  localStorage.setItem('page', page);
  //window.location.replace('/')
  //window.location.reload();
}


const login_ep = process.env.REACT_APP_BE_API_BASE_URL + "/api/login";

// Main App component for the login page
const LoginPage: React.FC<LoginPageProps> = ({ onLoginSuccess }) => {
  // State for username/email input
  const [username, setUsername] = useState<string>('');
  // State for password input
  const [password, setPassword] = useState<string>('');
  // State for "remember me" checkbox
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  // State for displaying messages (e.g., login success/error)
  const [message, setMessage] = useState<string>('');
  // State to control message visibility
  const [showMessage, setShowMessage] = useState<boolean>(false);

  // useEffect hook to load saved username/email from localStorage on component mount
  useEffect(() => {
    const savedUsername = localStorage.getItem('rememberedUsername');
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true); // Automatically check "remember me" if a username was found
    }
  }, []); // Empty dependency array means this runs once on mount

  // Function to handle form submission
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission behavior (page reload)

    // Basic validation: check if both fields are filled
    if (!username || !password) {
      showMessageBox('Please enter both username/email and password.', 'error');
      return;
    }

    // In a real application, you would send these credentials to an authentication API.
    // For this example, we'll simulate a successful login.
    console.log('Attempting login with:', { username, password, rememberMe });


    axios.post(login_ep, {
      userName: username,
      password: password,
    }, {
      headers: {
        'Authorization': process.env.REACT_APP_BE_API_BASIC_AUTH || '',
      }
    }).then((response) => {
      console.log(`Login response= ${JSON.stringify(response.data, null, 2)}`);
      if (response.status === 200) {
        //console.log('Login successful!');
        onLoginSuccess(username, rememberMe); // Pass rememberMe state to callback
        showMessageBox('Login successful!', 'success');

        //const user
        const user = (response.data as { user: string }).user;
        console.log(`Logged in user: ${user}`);
        localStorage.setItem('loggedInUserObj', JSON.stringify(user));
      }
    }).catch((error) => {
      console.error(`Login error: ${error.status} | ${error} `);
      if (error.status === 401) {

        setMessage('Invalid email or password.');
        showMessageBox('Login error!', 'error');

      }
    });

    // Simulate API call delay
    /* setTimeout(() => {
      // Simulate successful login
      if (username === 'admin@tsl.com' && password === 'tsl@202508') {
        console.log('Login successful!');
        onLoginSuccess(username, rememberMe); // Pass rememberMe state to callback
        showMessageBox('Login successful!', 'success');
      } else {
        setMessage('Invalid email or password. (Hint: user@example.com / password123)');
        showMessageBox('Login error!', 'error');
      }
    }, 1000); */

    // Simulate API call success
    

    // Handle "remember me" logic
    if (rememberMe) {
      localStorage.setItem('rememberedUsername', username); // Save username to localStorage
    } else {
      localStorage.removeItem('rememberedUsername'); // Remove username if "remember me" is unchecked
    }

    // Clear password after submission for security
    setPassword('');
    onNavigate('Inbox');
  };

  // Function to display a message box
  const showMessageBox = (msg: string, type: 'success' | 'error') => {

    let retainTimeMs = 0;
    if (type === 'error') {
      retainTimeMs = 10000; // Show error messages longer
    }else {
      retainTimeMs = 800; // Show success messages for a shorter time
    }
    setMessage(msg);
    setShowMessage(true);
    // Set a timeout to hide the message after 3 seconds
    setTimeout(() => {
      setShowMessage(false);
      setMessage('');
    }, retainTimeMs);
  };

  return (
    // Main container with custom CSS class for centering and styling
    <>
      <div className='login-main-container'>


    <div className="login-page-container">
      <div className="login-card">
        <div className="flex items-center justify-center   rounded-lg text-white font-bold text-lg">
          <img src="/images/RGD_logo_lg.png" width={'50%'} height={'50%'} alt="Logo" className="h-8 w-8 mr-2" />
        </div>
        <h2 className="login-title">Login</h2>

        {/* Message Box */}
        {showMessage && (
          <div
            className={`message-box ${message.includes('successful') ? 'success' : 'error'}`}
            role="alert"
          >
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          {/* Username/Email Input */}
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              Username or Email
            </label>
            <input
              type="text"
              id="username"
              className="input-field"
              placeholder="Enter your username or email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              aria-label="Username or Email"
            />
          </div>

          {/* Password Input */}
          <div className="form-group">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="password"
              className="input-field"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              aria-label="Password"
            />
          </div>

          {/* Remember Me Checkbox */}
          <div className="checkbox-group">
            <input
              type="checkbox"
              id="rememberMe"
              className="checkbox-input"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              aria-label="Remember me"
            />
            <label htmlFor="rememberMe" className="checkbox-label">
              Remember me
            </label>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="login-button"
            aria-label="Login"
          >
            Login
          </button>

          {/* Optional: Forgot Password / Sign Up Links */}
          <div className="link-container">
            <a href="#" className="link-text">
              Forgot Password?
            </a>

          </div>
        </form>
      </div>
    </div>
          </div>
    </>
  );
};

export default LoginPage;
